module.exports = __webpack_public_path__ + "img/kyc-manual-verification.f66433d2.svg";